module.exports = __webpack_public_path__ + "img/habits.10ddd390.webp";